import React, { Children } from 'react';
import { useTranslation } from 'react-i18next';
import { ArrowLeftIcon } from 'lucide-react';
import { formatCurrencyAmount } from '../../../theme/tokens';
export function ReservationDetail() {
  const {
    t
  } = useTranslation('rooms');
  const reservation = {
    pnr: 'FRU91DGE',
    status: 'confirmed',
    date: {
      checkIn: '10 May 2026',
      checkOut: '11 May 2026',
      nights: 1
    },
    guests: {
      adults: 2,
      children: 0,
      infants: 0,
      rooms: 1
    },
    booking: {
      id: '68d67b3d2e37218960b356f',
      transactionId: '68d67b3dd025cb0f2d99f912'
    },
    hotel: {
      name: 'BML Paradise Shores Resort',
      id: '689eeaf67b0e1e34cf4940b8'
    },
    room: {
      name: 'Premium Overwater Villa',
      view: 'SEA_VIEW',
      category: 'OVERWATER_VILLA'
    },
    guest: {
      name: 'Ahmed Waheed',
      email: 'sujau@bml.com.mv',
      phone: '+9607908663',
      passport: 'saaa',
      dateOfBirth: '25 Feb 2017',
      nationality: 'MDV',
      specialRequests: ''
    },
    rate: {
      name: 'Advance Booking with Free Seaplan Transfer',
      description: 'Plan your Langkawi escape early and enjoy the added luxury of a complimentary round-trip ferry transfer from Kuala Kedah to the resort. This exclusive offer rewards advance planners with both value and convenience, ensuring your journey is as seamless as your stay. Book 14 days in advance.'
    },
    price: {
      subtotal: formatCurrencyAmount(1.0, {
        fractionDigits: 2
      }),
      serviceCharge: formatCurrencyAmount(0.1, {
        fractionDigits: 2
      })
    }
  };
  const navigateBack = () => {
    window.location.href = '/reservations';
  };
  return <div className="space-y-6" data-id="element-10240" data-mp="1h75fkwo7go0s">
      {/* Header with back button */}
      <div className="flex items-center space-x-2" data-id="element-10241" data-mp="36kqxyh46fneo">
        <button onClick={navigateBack} className="flex items-center text-gray-600 hover:text-gray-900" data-id="element-10242" data-mp="36j7j8uy65kf0">
          <ArrowLeftIcon size={18} className="mr-1" data-id="element-10243" data-mp="395gq2n91ayhp" />
          <span data-id="element-10244" data-mp="3971hi401y1bc">{t('pages.ReservationDetail.reservation_details')}</span>
        </button>
      </div>
      {/* Reservation Details Card */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" data-id="element-10245" data-mp="304s7rgclybz0">
        {/* Reservation Header */}
        <div className="p-6 border-b border-gray-200" data-id="element-10246" data-mp="2v6z4ow6lpy2y">
          <div className="flex justify-between items-center" data-id="element-10247" data-mp="2v8a3sip3qhnq">
            <h2 className="text-xl font-bold" data-id="element-10248" data-mp="3st6842r65kdq">{reservation.pnr}</h2>
            <div className="flex space-x-4" data-id="element-10249" data-mp="3nucrw2khzf9v">
              <span className="px-3 py-1 bg-green-100 text-green-800 text-sm font-semibold rounded-full" data-id="element-10250" data-mp="3nvedh0z53k5u">
                {t('pages.ReservationDetail.confirmed')}
              </span>
              <button className="px-4 py-2 border border-red-500 text-red-500 rounded-md hover:bg-red-50" data-id="element-10251" data-mp="3e4a0u7wxsbe6">
                {t('pages.ReservationDetail.resend_confirmation_email')}
              </button>
            </div>
          </div>
        </div>
        {/* Reservation Overview */}
        <div className="grid grid-cols-1 md:grid-cols-2 border-b border-gray-200" data-id="element-10252" data-mp="i0j00em8af0d">
          <div className="p-6 border-r border-gray-200" data-id="element-10253" data-mp="mxivxwpd61dr">
            <h3 className="text-sm font-medium text-gray-500 mb-2" data-id="element-10254" data-mp="n05bojmern72">
              {t('pages.ReservationDetail.date')}
            </h3>
            <p className="text-gray-900 font-medium" data-id="element-10255" data-mp="wwrwx9incg9m">
              {reservation.date.checkIn} - {reservation.date.checkOut}
            </p>
            <p className="text-sm text-gray-500" data-id="element-10256" data-mp="10xtmszqobfyx">
              {reservation.date.nights} {t('pages.ReservationDetail.nights')}
            </p>
          </div>
          <div className="p-6" data-id="element-10257" data-mp="1anmwfv799l0j">
            <h3 className="text-sm font-medium text-gray-500 mb-2" data-id="element-10258" data-mp="1aoet79cl9ose">
              {t('pages.ReservationDetail.guests_rooms')}
            </h3>
            <p className="text-gray-900 font-medium" data-id="element-10259" data-mp="1kmch1vqjdjkh">
              {reservation.guests.adults} {t('pages.ReservationDetail.adults')}{' '}
              {reservation.guests.children}{' '}
              {t('pages.ReservationDetail.children')}{' '}
              {reservation.guests.infants}{' '}
              {t('pages.ReservationDetail.infants')}
            </p>
            <p className="text-sm text-gray-500" data-id="element-10260" data-mp="2hd7kbkumbdm4">
              {reservation.guests.rooms} {t('pages.ReservationDetail.room')}
            </p>
          </div>
        </div>
        {/* Booking Information */}
        <div className="p-6 border-b border-gray-200" data-id="element-10261" data-mp="2r5dlnl6rf7dz">
          <h3 className="text-sm font-semibold mb-4" data-id="element-10262" data-mp="23epzpw00eh8f">
            {t('pages.ReservationDetail.booking_information')}
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-10263" data-mp="1ygg45kadhema">
            <div data-id="element-10264" data-mp="2cffs0pq29phe">
              <p className="text-sm text-gray-500 mb-1" data-id="element-10265" data-mp="2cfxx8bupbe1g">
                {t('pages.ReservationDetail.booking_id')}
              </p>
              <p className="text-sm text-gray-900" data-id="element-10266" data-mp="27hmltworcvh4">{reservation.booking.id}</p>
            </div>
            <div data-id="element-10267" data-mp="3nvcsnb79hxug">
              <p className="text-sm text-gray-500 mb-1" data-id="element-10268" data-mp="3iup3kv2lfr2v">
                {t('pages.ReservationDetail.transaction_id')}
              </p>
              <p className="text-sm text-gray-900" data-id="element-10269" data-mp="3rao3auucunqz">
                {reservation.booking.transactionId}
              </p>
            </div>
          </div>
        </div>
        {/* Hotel Information */}
        <div className="p-6 border-b border-gray-200" data-id="element-10270" data-mp="3hel1xr7but53">
          <h3 className="text-sm font-semibold mb-4" data-id="element-10271" data-mp="3mccpya4upv40">
            {t('pages.PropertyInformation.hotel')}
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-10272" data-mp="dwaywa1vdqex">
            <div data-id="element-10273" data-mp="dyx8sgc8gi0b">
              <p className="text-sm text-gray-500 mb-1" data-id="element-10274" data-mp="ive2dq27boks">
                {t('pages.ReservationDetail.name')}
              </p>
              <p className="text-sm text-gray-900" data-id="element-10275" data-mp="45q5r24yte3e">{reservation.hotel.name}</p>
            </div>
            <div data-id="element-10276" data-mp="94sxxlzujpty">
              <p className="text-sm text-gray-500 mb-1" data-id="element-10277" data-mp="949pqx000ft4">
                {t('pages.ReservationDetail.hotel_id')}
              </p>
              <p className="text-sm text-gray-900" data-id="element-10278" data-mp="wtlvfmw4a5qo">{reservation.hotel.id}</p>
            </div>
          </div>
        </div>
        {/* Room Type Information */}
        <div className="p-6 border-b border-gray-200" data-id="element-10279" data-mp="1bgt2hhihejka">
          <h3 className="text-sm font-semibold mb-4" data-id="element-10280" data-mp="16jaovdtirg5y">
            {t('pages.Rates.room_type')}
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-10281" data-mp="11jeum6amj33l">
            <div data-id="element-10282" data-mp="11lsoibtki99k">
              <p className="text-sm text-gray-500 mb-1" data-id="element-10283" data-mp="ximldd1r4y7b">
                {t('pages.ReservationDetail.name')}
              </p>
              <p className="text-sm text-gray-900" data-id="element-10284" data-mp="skbcb4ja6rq5">{reservation.room.name}</p>
            </div>
            <div data-id="element-10285" data-mp="ns9pioohlilv">
              <p className="text-sm text-gray-500 mb-1" data-id="element-10286" data-mp="nrrozfuski85">
                {t('pages.ReservationDetail.view')}
              </p>
              <p className="text-sm text-gray-900" data-id="element-10287" data-mp="irdqopizsmnb">{reservation.room.view}</p>
            </div>
            <div data-id="element-10288" data-mp="dsaiiw7pu0b4">
              <p className="text-sm text-gray-500 mb-1" data-id="element-10289" data-mp="9ssah10ztjpp">
                {t('pages.ReservationDetail.category')}
              </p>
              <p className="text-sm text-gray-900" data-id="element-10290" data-mp="4tfbjhwukm6r">
                {reservation.room.category}
              </p>
            </div>
          </div>
        </div>
        {/* Guest Information */}
        <div className="p-6 border-b border-gray-200" data-id="element-10291" data-mp="2lflz8e5ahn6j">
          <h3 className="text-sm font-semibold mb-4" data-id="element-10292" data-mp="2li88qjbqqcre">
            {t('pages.ReservationDetail.guest_information')}
          </h3>
          <div className="border border-gray-200 rounded-lg p-4" data-id="element-10293" data-mp="2ugjtw5tu8icg">
            <h4 className="text-base font-medium mb-4" data-id="element-10294" data-mp="2uepknorxieo7">
              {reservation.guest.name}
            </h4>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-10295" data-mp="1xoq2r3pw23sy">
              <div data-id="element-10296" data-mp="21snzj7rqr2iu">
                <p className="text-sm text-gray-500 mb-1" data-id="element-10297" data-mp="21q1wnlfspb6y">
                  {t('pages.ReservationDetail.email')}
                </p>
                <p className="text-sm text-gray-900" data-id="element-10298" data-mp="2bihdgffcvtq9">
                  {reservation.guest.email}
                </p>
              </div>
              <div data-id="element-10299" data-mp="1e20rmmhtscwa">
                <p className="text-sm text-gray-500 mb-1" data-id="element-10300" data-mp="1e0hbcvw661ui">
                  {t('pages.PropertyInformation.phone_number')}
                </p>
                <p className="text-sm text-gray-900" data-id="element-10301" data-mp="cdsv95gskztr">
                  {reservation.guest.phone}
                </p>
              </div>
              <div data-id="element-10302" data-mp="7gspkvnutz36">
                <p className="text-sm text-gray-500 mb-1" data-id="element-10303" data-mp="7hc9ghx2exju">
                  {t('pages.ReservationDetail.passport_number')}
                </p>
                <p className="text-sm text-gray-900" data-id="element-10304" data-mp="hd5s8j1dnna2">
                  {reservation.guest.passport}
                </p>
              </div>
              <div data-id="element-10305" data-mp="vbc7ehyjqyke">
                <p className="text-sm text-gray-500 mb-1" data-id="element-10306" data-mp="vau2yy1qde1e">
                  {t('pages.ReservationDetail.date_of_birth')}
                </p>
                <p className="text-sm text-gray-900" data-id="element-10307" data-mp="1539kju9480lr">
                  {reservation.guest.dateOfBirth}
                </p>
              </div>
              <div data-id="element-10308" data-mp="105zy8nh0w525">
                <p className="text-sm text-gray-500 mb-1" data-id="element-10309" data-mp="1e3o70wxtflqu">
                  {t('pages.ReservationDetail.nationality')}
                </p>
                <p className="text-sm text-gray-900" data-id="element-10310" data-mp="195mms8onlgds">
                  {reservation.guest.nationality}
                </p>
              </div>
              <div data-id="element-10311" data-mp="1soajmnm7olwq">
                <p className="text-sm text-gray-500 mb-1" data-id="element-10312" data-mp="1xp7x4mwa0rrw">
                  {t('pages.ReservationDetail.special_requests')}
                </p>
                <p className="text-sm text-gray-900" data-id="element-10313" data-mp="1jox5vir21b67">
                  {reservation.guest.specialRequests || 'None'}
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* Rate Details */}
        <div className="p-6 border-b border-gray-200" data-id="element-10314" data-mp="19xstmqsrk4f2">
          <h3 className="text-sm font-semibold mb-4" data-id="element-10315" data-mp="1ernhm6fej5jy">
            {t('pages.ReservationDetail.rate_details')}
          </h3>
          <div className="grid grid-cols-1 gap-4" data-id="element-10316" data-mp="103iy508iyq04">
            <div data-id="element-10317" data-mp="1509ezps5lpml">
              <p className="text-sm text-gray-500 mb-1" data-id="element-10318" data-mp="151u6t7n32ugr">
                {t('pages.ReservationDetail.rate_name')}
              </p>
              <p className="text-sm text-gray-900" data-id="element-10319" data-mp="r1t55pyzvj08">{reservation.rate.name}</p>
            </div>
            <div data-id="element-10320" data-mp="vzb6ovaomvy7">
              <p className="text-sm text-gray-500 mb-1" data-id="element-10321" data-mp="w1xf0x5edfhh">
                {t('components.AddRoomForm.description')}
              </p>
              <p className="text-sm text-gray-900" data-id="element-10322" data-mp="3cx63g8vo4bz6">
                {reservation.rate.description}
              </p>
            </div>
          </div>
        </div>
        {/* Price Breakdown */}
        <div className="p-6" data-id="element-10323" data-mp="33vga2xi872yr">
          <h3 className="text-sm font-semibold mb-4" data-id="element-10324" data-mp="33wrft2v8eksi">
            {t('pages.ReservationDetail.price_breakdown')}
          </h3>
          <div className="space-y-3" data-id="element-10325" data-mp="3rnnduhqa6c87">
            <div className="flex justify-between" data-id="element-10326" data-mp="3vnnrw19gwleq">
              <p className="text-sm text-gray-500" data-id="element-10327" data-mp="3vmclrusjv1kg">
                {t('pages.ReservationDetail.subtotal')}
              </p>
              <p className="text-sm text-gray-900" data-id="element-10328" data-mp="3muu9vw2mz7x6">
                {reservation.price.subtotal}
              </p>
            </div>
            <div className="flex justify-between" data-id="element-10329" data-mp="eeqypgcbf143">
              <p className="text-sm text-gray-500" data-id="element-10330" data-mp="ecxvyc4tp11d">
                {t('pages.ReservationDetail.service_charge')}
              </p>
              <p className="text-sm text-gray-900" data-id="element-10331" data-mp="sk12v475fz1b">
                {reservation.price.serviceCharge}
              </p>
            </div>
            <div className="border-t border-gray-200 pt-3 flex justify-between" data-id="element-10332" data-mp="oifvfyddwcyi">
              <p className="text-sm font-medium" data-id="element-10333" data-mp="129aukiy2zfow">
                {t('pages.ReservationDetail.total')}
              </p>
              <p className="text-sm font-bold" data-id="element-10334" data-mp="xbsvdk9v8eu3">$1.10</p>
            </div>
          </div>
        </div>
      </div>
    </div>;
}